import { datoToken } from 'js/config'
import history from './historyObject'

export function isPreview(search) {
  const params = new URLSearchParams(search || history.location.search)
  return params.has('preview')
}

export function getCache(slug, language) {
  if (isPreview()) return Promise.reject(slug)

  return import(
    /* webpackChunkName: "[request]" */ `wp-data/${slug}-${language}.json`
  )
    .then(({ default: data }) => data)
    .catch(error => {
      console.error(
        'Could not fetch cached version, fetching from dato.',
        error
      )
      return Promise.reject(slug)
    })
}

export function runQuery(query, search) {
  const TOKEN = datoToken
  const preview = isPreview(search)

  return fetch(
    preview
      ? 'https://graphql.datocms.com/preview'
      : 'https://graphql.datocms.com/',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${TOKEN}`,
      },
      body: JSON.stringify({
        query,
      }),
    }
  )
    .then(res => res.json())
    .then(json => {
      if (!json.errors) return json.data
      throw json.errors
    })
    .catch(error => {
      console.error(
        'QUERY ERROR',
        error.map(error => error.message).join('\n'),
        'on query',
        query,
        'Errors: ',
        error
      )
      throw error
    })
}
